import { Grid, Typography } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import { makeStyles } from "@material-ui/core/styles";
import * as React from "react";
import { useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";
import { GetTranslation } from "../../../../translations/GetTranslation";
import FormGridCell from "../../../common/FormGridCell";
import { useSignUpContext } from "../../CertificationDataWizardContext/CertificationDataWizardContext";
import { CountrySelectField, RadioInput, TextInput } from "../shared/Fields";

const useStyles = makeStyles({
  address: {
    paddingTop: 25,
  },
  businessData: {
    paddingTop: 10,
  },
});

const CandidateAddressFields = () => {
  const intl = useIntl();
  const {
    data: { candidate },
  } = useSignUpContext();
  const { watch, setValue } = useFormContext();

  const preferredContact = watch("preferredContact");

  const classes = useStyles();

  React.useEffect(() => {
    setValue("privateIsPreferredContact", preferredContact === "private");
  }, [preferredContact, setValue]);

  return (
    <>
      <Typography variant="h6" className={classes.address}>
        {GetTranslation(intl, "person.section.address")}
      </Typography>
      <Grid container={true} spacing={4}>
        <FormGridCell size="fourth">
          <TextInput name="street" label={GetTranslation(intl, "person.field.street")} required />
        </FormGridCell>
        <FormGridCell size="sixth">
          <TextInput
            name="streetNumber"
            label={GetTranslation(intl, "person.field.streetNumber")}
            required
            inputProps={{ maxLength: 9 }}
          />
        </FormGridCell>
        <FormGridCell size="sixth">
          <TextInput
            name="zipCode"
            label={GetTranslation(intl, "person.field.zipCode")}
            required
          />
        </FormGridCell>
        <FormGridCell size="sixth">
          <TextInput name="city" label={GetTranslation(intl, "person.field.city")} required />
        </FormGridCell>
        <FormGridCell size="fourth">
          <CountrySelectField
            name="country"
            label={GetTranslation(intl, "person.field.country")}
            defaultValue={candidate.country}
            required
          />
        </FormGridCell>
        <FormGridCell size="third">
          <RadioInput
            name="correspondenceLanguage"
            label={GetTranslation(intl, "candidate.field.correspondenceLanguage")}
            defaultValue={candidate.correspondenceLanguage}
            required
          >
            <FormControlLabel value="DE" control={<Radio />} label={GetTranslation(intl, "common.language.de")} />
            <FormControlLabel value="FR" control={<Radio />} label={GetTranslation(intl, "common.language.fr")} />
            <FormControlLabel value="IT" control={<Radio />} label={GetTranslation(intl, "common.language.it")} />
          </RadioInput>
        </FormGridCell>
        <FormGridCell size="third">
          <RadioInput
            name="preferredContact"
            label={GetTranslation(intl, "candidate.field.invoiceRecipient")}
            defaultValue={candidate.privateIsPreferredContact ? "private" : "business"}
          >
            <FormControlLabel value="private" control={<Radio />} label={GetTranslation(intl, "common.private")} />
            <FormControlLabel value="business" control={<Radio />} label={GetTranslation(intl, "common.business")} />
          </RadioInput>
        </FormGridCell>
      </Grid>
      {preferredContact === "business" && (
        <>
          <Typography variant="h6">{GetTranslation(intl, "person.section.businessData")}</Typography>
          <Grid container={true} spacing={4}>
            <FormGridCell size="third">
              <TextInput name="employer" label={GetTranslation(intl, "person.field.employer")} required />
            </FormGridCell>
            <FormGridCell size="third">
              <TextInput name="employerStreet" label={GetTranslation(intl, "person.field.employerStreet")} required />
            </FormGridCell>
            <FormGridCell size="third">
              <TextInput
                name="employerStreetNumber"
                label={GetTranslation(intl, "person.field.employerStreetNumber")}
                required
                inputProps={{ maxLength: 9 }}
              />
            </FormGridCell>
            <FormGridCell size="third">
              <TextInput
                name="employerZipCode"
                label={GetTranslation(intl, "person.field.employerZipCode")}
                required
              />
            </FormGridCell>
            <FormGridCell size="third">
              <TextInput name="employerCity" label={GetTranslation(intl, "person.field.employerCity")} required />
            </FormGridCell>
            <FormGridCell size="third">
              <CountrySelectField
                name="employerCountry"
                label={GetTranslation(intl, "person.field.country")}
                defaultValue={candidate.country}
                required
              />
            </FormGridCell>
          </Grid>
        </>
      )}
    </>
  );
};

export default CandidateAddressFields;
